export const blockIconsSocialMilitaryTechNew = (
	<span className='material-symbols-outlined'>military_tech</span>
);
